__turbopack_context__.v({
  "iconOnlyTrigger": "download-menu-button-module-scss-module__vcCFQa__iconOnlyTrigger",
  "menu": "download-menu-button-module-scss-module__vcCFQa__menu",
  "menuAlignLeft": "download-menu-button-module-scss-module__vcCFQa__menuAlignLeft",
  "menuAlignRight": "download-menu-button-module-scss-module__vcCFQa__menuAlignRight",
  "menuDirectionDown": "download-menu-button-module-scss-module__vcCFQa__menuDirectionDown",
  "menuDirectionUp": "download-menu-button-module-scss-module__vcCFQa__menuDirectionUp",
  "menuItem": "download-menu-button-module-scss-module__vcCFQa__menuItem",
  "menuItemLabel": "download-menu-button-module-scss-module__vcCFQa__menuItemLabel",
  "menuItemMeta": "download-menu-button-module-scss-module__vcCFQa__menuItemMeta",
  "triggerLabel": "download-menu-button-module-scss-module__vcCFQa__triggerLabel",
  "wrapper": "download-menu-button-module-scss-module__vcCFQa__wrapper",
});
